/* Ott-common */
import { normalize, schema } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/* Utils */
import {
  AssetEntity,
  EntityName,
  StationEntity,
  ShowEntity,
  VodContentEntity,
  LiveContentEntity,
  schemaAttribute,
  normalizeSearchResults,
} from '../../utils';

const searchResultsSchema = new schema.Array({
  [EntityName.SHOW]: ShowEntity,
  [EntityName.STATION]: StationEntity,
  [EntityName.VOD_CONTENT]: VodContentEntity,
  [EntityName.LIVE_CONTENT]: LiveContentEntity,
}, schemaAttribute);

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function assets(backendAxiosInstance) {
  /**
   * @param {string} assetId
   */
  async function getAssetById(assetId) {
    const response = await backendAxiosInstance.get(`/content/v1/Assets/getById/${assetId}`, {
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize(response.data, AssetEntity);

    return response;
  }

  /**
   * @typedef ContentRecommendationsParams
   * @type {object}
   * @property {string} query
   * @property {number} [count]
   */

  /**
   * @param {ContentRecommendationsParams} contentRecommendationsParams
   */
  async function searchContentRecommendations(contentRecommendationsParams) {
    const response = await backendAxiosInstance.get(
      '/content/v1/extensions/assets/search',
      {
        includeClientType: true,
        includeTimeZone: true,
        includeEntitlements: true,
        authType: AuthType.SESSION_TOKEN,
        params: contentRecommendationsParams,
      },
    );

    response.normalizedData = normalize(
      normalizeSearchResults(response.data.results),
      searchResultsSchema,
    );

    return response;
  }

  return {
    getAssetById,
    searchContentRecommendations,
  };
}
